import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const approveEntityAction = async (onboardingId, spocEmailAddress) => {
    try {
        const payload = {
            onboardingId: onboardingId || 0,

            spocEmailAddress: spocEmailAddress || "",
        };

        const response = await apiClient.put(ATP_API_URL.APPROVE_ENTITY, payload);

        if (response?.status === 200) {
            if (response.data?.success === false) {
                return { success: false, message: response.data.message || "Failed to approve entity" };
            }
            return { success: true, message: response.data?.message || "Entity approved successfully" };
        }

        return { success: false, message: "Failed to approve entity" };
    } catch (error) {
        console.error("❌ Error approving entity:", error);
        return { success: false, message: error.message || "Failed to approve entity" };
    }
};
